import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, FreeMode } from 'swiper/modules';
import logoCompany1 from '@/assets/landing/images/logo/logo-company-1.svg';
import logoCompany2 from '@/assets/landing/images/logo/logo-company-2.svg';
import logoCompany3 from '@/assets/landing/images/logo/logo-company-3.svg';
import logoCompany4 from '@/assets/landing/images/logo/logo-company-4.svg';
import logoCompany5 from '@/assets/landing/images/logo/logo-company-5.svg';
import logoCompany6 from '@/assets/landing/images/logo/logo-company-6.svg';
import logoCompany7 from '@/assets/landing/images/logo/logo-company-7.svg';
import logoCompany8 from '@/assets/landing/images/logo/logo-company-8.svg';

import 'swiper/css';

export default function LogoSection() {
  const logos = [
    logoCompany1,
    logoCompany2,
    logoCompany3,
    logoCompany4,
    logoCompany5,
    logoCompany6,
    logoCompany7,
    logoCompany8,
  ];

  return (
    <section className="bg-[#F7FF91] py-8 sm:py-12 md:py-16 lg:py-20 xl:py-24">
      <div className="landing-container relative">
        <div className="relative overflow-hidden h-[80px] flex items-center">
          <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-[#F7FF91] to-transparent z-10 pointer-events-none"></div>
          <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-[#F7FF91] to-transparent z-10 pointer-events-none"></div>
          <Swiper
            modules={[Autoplay, FreeMode]}
            spaceBetween={30}
            slidesPerView="auto"
            loop
            autoplay={{
              delay: 1,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={4000}
            allowTouchMove={false}
            freeMode={{
              enabled: true,
              momentum: false,
            }}
            touchRatio={0}
            touchAngle={0}
            simulateTouch={false}
            grabCursor={false}
            className="logo-swiper"
          >
            {[...logos, ...logos].map((logo, index) => (
              <SwiperSlide key={index} className="!w-auto flex items-center">
                <div className="flex items-center justify-center mx-8 h-full">
                  <img src={logo} alt="Partner Logo" className="max-h-[80px] object-contain opacity-80 hover:opacity-100 transition-opacity duration-300" />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

